import axios from 'axios'
import md5 from './../assets/js/md5.min.js'


axios.defaults.baseURL = "https://probedb.leadartech.cn/openapi";
//axios.defaults.baseURL = "https://work.kuujia.web960.com:8780/openapi";
window["authtoken"] = "";
window["getauthtoken"] = function () {
  var authtoken = localStorage.getItem("authtoken");
  return authtoken;
};
window["logincallbackqueue"] = {
};
window["apicallbackhandle"] = function (config) {
  var url = config.url.replace("/openapi/", "/");
  var pdata = "{}";
  if (config["data"] != null) {
    pdata = config["data"];
  }
  var md5key = md5.md5(url + pdata + config.method);
  delete window["logincallbackqueue"][md5key];
}
// 请求超时时间
axios.defaults.timeout = 60000;
axios.defaults.headers.post['Content-Type'] = 'application/json'

// 请求拦截器
axios.interceptors.request.use(config => {
  // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
  // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
  if (config.url.indexOf("/user/login") == -1) {
    var pdata = "{}";
    if (config["data"] != null) {
      pdata = config["data"];
    }
    var md5key = md5.md5(config.url + pdata + config.method);
    window["logincallbackqueue"][md5key] = { url: config.url, params: JSON.parse(pdata), method: config.method };

  }
  config.headers.Authorization = window["getauthtoken"]();
  return config;
},
  error => {

    return Promise.error(error);
  })

// 响应拦截器
axios.interceptors.response.use(response => {
  if (response.status != 401) {
    window["apicallbackhandle"](response.config);
  }
  if (response.status === 200) {

    if (response.data["result"] != "1") {
      toastr.error(response.data["message"], "错误", {
        closeButton: true,
        progressBar: true,
        newestOnTop: true
      });
      return Promise.resolve(response);
    }
    else {
      return Promise.resolve(response);
    }

  } else {
    return Promise.reject(response);
  }
},
  // 服务器状态码不是200的情况    
  error => {
    //console.log(window["appld"]);
    if (error.response && error.response.status) {

      if (error.response.status != 401) {

        window["apicallbackhandle"](response.config);
      }
      switch (error.response.status) {
        // 401: 未登录                
        // 未登录则跳转登录页面，并携带当前页面的路径                
        // 在登录成功后返回当前页面，这一步需要在登录页操作。                
        case 401:
          window["__tmpcurrentuser"].isLogined = false;//是否登陆
          appvm.needLogin = true;
          location.href = "/login";
          break;
        // 403 token过期                
        // 登录过期对用户进行提示                
        // 清除本地token和清空vuex中token对象                
        // 跳转登录页面                
        case 403:
          toastr.error("登录过期，请重新登录", "错误", {
            closeButton: true,
            progressBar: true,
            newestOnTop: true
          });
          // 清除token                    
          localStorage.removeItem('token');
          store.commit('loginSuccess', null);
          location.href = "/login";
          // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          setTimeout(() => {
            router.replace({
              path: '/login',
              query: {
                redirect: router.currentRoute.fullPath
              }
            });

          }, 1000);
          break;
        // 404请求不存在                
        case 404:
          toastr.error("网络请求不存在", "错误", {
            closeButton: true,
            progressBar: true,
            newestOnTop: true
          });
          break;
        // 其他错误，直接抛出错误提示                
        default:
          toastr.error(error.response.data.message, "错误", {
            closeButton: true,
            progressBar: true,
            newestOnTop: true
          });
      }
      return Promise.reject(error.response);
    }
  })

// 封装axios的post请求
export function fetchPost(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(response => {
        if (response) {
          resolve(response.data)
        }

      })
      .catch((error) => {

        reject(error)
      })
  })
}

export function get(url, params) {

  if (url.substr(0, 1) != "/") {
    url = "/" + url;
  }

  return new Promise(function (resolve, reject) {
    axios.get(url, {
      params: params
    })
      .then(res => {
        kjapi.dataformatter(res.data, function (ret) {
          resolve(posturl);
        });
      })
      .catch(err => {
        reject(err.data)
      })
  });
}

export default {
  getTableData(url, params) {
    let posturl = url;
    if (url.indexOf("http://") == -1) {
      posturl = axios.defaults.baseURL + url;
    }
    return fetchPost(posturl, params)
  },
  getData(url, params) {
    let posturl = axios.defaults.baseURL + url;
    return get(url, params)
  }
}



// WEBPACK FOOTER //
// ./src/axios/api.js